import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

/** White oval arc at the bottom of the hero — deeper curve on desktop */
const HeroCurve = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        bottom: -1,
        left: 0,
        right: 0,
        lineHeight: 0,
        zIndex: 2,
        pointerEvents: 'none',
      }}
    >
      <svg
        viewBox="0 0 1440 160"
        preserveAspectRatio="none"
        style={{
          display: 'block',
          width: '100%',
          height: isMobile ? 72 : 112,
        }}
      >
        <path
          d={
            isMobile
              ? 'M0,160 L0,105 Q720,20 1440,105 L1440,160 Z'
              : 'M0,160 L0,95 Q720,-20 1440,95 L1440,160 Z'
          }
          fill="#ffffff"
        />
      </svg>
    </Box>
  );
};

export default HeroCurve;
